import { render, staticRenderFns } from "./ControlPanelUserHeader.vue?vue&type=template&id=1849f7ec"
import script from "./ControlPanelUserHeader.vue?vue&type=script&lang=ts"
export * from "./ControlPanelUserHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.28.5__cache-loader@4.1.0_web_440794991c458c99f4ea4042de23b4db/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ZAvatar: require('/app/components/zeal/ZAvatar/ZAvatar.vue').default,ScimIconWrapper: require('/app/components/ControlPanel/ScimIconWrapper.vue').default,ZTag: require('/app/components/zeal/ZTag/ZTag.vue').default,ZIcon: require('/app/components/zeal/ZIcon/ZIcon.vue').default,NuxtLinkButton: require('/app/components/NuxtLinkButton.vue').default,ToggleUserActiveButton: require('/app/components/ControlPanel/ToggleUserActiveButton.vue').default,DeleteUserButton: require('/app/components/ControlPanel/DeleteUserButton.vue').default})
